//@flow
import * as Immutable from 'immutable';

import { BaseLocations } from 'common/models/flow/BaseLocations';
import type { BaseLocationsModelType } from 'common/models/flow/BaseLocations';

import {
    validatable,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import { AddressLatLng } from './AddressLatLng';

@validatable
class InternalBaseLocations extends BaseLocations {
    static fromJS(json: BaseLocationsModelType): InternalBaseLocations {
        const state: Object = Object.assign({}, json);
        state.startLocation = state.startLocation
            ? AddressLatLng.fromJS(state.startLocation)
            : state.startLocation;
        state.endLocation = state.endLocation
            ? AddressLatLng.fromJS(state.endLocation)
            : state.endLocation;
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        const { startLocation, endLocation } = this;
        if (startLocation && startLocation.hasValidationErrors()) {
            return true;
        }
        if (endLocation && endLocation.hasValidationErrors()) {
            return true;
        }
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        let { startLocation, endLocation } = this;
        if (startLocation) {
            startLocation = startLocation.setAllValidationErrors();
        }
        if (endLocation) {
            endLocation = endLocation.setAllValidationErrors();
        }
        return this.setStartLocation(startLocation).setEndLocation(endLocation);
    }

    get startLocation(): ?AddressLatLng {
        return this._state.get('startLocation');
    }

    get endLocation(): ?AddressLatLng {
        return this._state.get('endLocation');
    }

    // Alternative to lazy loading of nested models (init and cleaning)
    defaultSanitize(): ?this {
        const sanitizedBaseLocations = super.defaultSanitize();
        if (sanitizedBaseLocations) {
            const sanitizedStartLocation = sanitizedBaseLocations.startLocation?.defaultSanitize();
            const sanitizedEndLocation = sanitizedBaseLocations.endLocation?.defaultSanitize();

            return sanitizedBaseLocations
                .setStartLocation(sanitizedStartLocation)
                .setEndLocation(sanitizedEndLocation);
        }
        return sanitizedBaseLocations;
    }

    static defaultInit({ props }): InternalBaseLocations {
        const startLocation = AddressLatLng.defaultInit({ props });
        const endLocation = AddressLatLng.defaultInit({ props });

        return InternalBaseLocations.fromJS({})
            .setStartLocation(startLocation)
            .setEndLocation(endLocation);
    }
}

export { InternalBaseLocations as BaseLocations };
